import { useState } from 'react'
import { Link } from 'react-router-dom'
import { AgentMemoryPanel, CreateMemoryDialog } from '@/components/projects'
import { useAgentDetailContext } from '@/hooks'

export function AgentMemoryPage() {
  const { projectId, parsedConfig, canReadMemory, memoryAgentId, pendingMemories, onQueueMemory, onRemovePendingMemory, isSaving } = useAgentDetailContext()
  const [createOpen, setCreateOpen] = useState(false)

  if (!memoryAgentId && parsedConfig?.memory !== 'project' && pendingMemories.length === 0) {
    return (
      <div
        className="rounded-2xl border border-dashed border-border bg-table-row p-8 text-center text-sm text-muted-foreground"
        data-testid="agent-memory-disabled"
      >
        Memory is off for this agent. Turn it on in{' '}
        <Link to="../config" className="underline">Config → Memory Scope</Link> to let it remember facts between runs.
      </div>
    )
  }

  if (!canReadMemory) {
    return (
      <div
        className="rounded-2xl border border-dashed border-border bg-table-row p-8 text-center text-sm text-muted-foreground"
        data-testid="agent-memory-forbidden"
      >
        You need permission to edit agents before you can read what this one remembers.
      </div>
    )
  }

  return (
    <div data-testid="agent-memory-section">
      <AgentMemoryPanel
        projectId={projectId}
        agentId={memoryAgentId}
        pendingEntries={pendingMemories}
        onRemovePending={onRemovePendingMemory}
        onCreateClick={() => setCreateOpen(true)}
        changesLocked={isSaving}
      />
      <CreateMemoryDialog
        projectId={projectId}
        agentId={memoryAgentId}
        open={createOpen}
        onOpenChange={setCreateOpen}
        onQueue={memoryAgentId ? undefined : onQueueMemory}
      />
    </div>
  )
}
